/*
 * @Author: huangzq
 * @Date: 2020-03-20 14:13:53
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-06-17 14:59:54
 * @Desc: 宣传册-预览-底部swiper效果
*/
<template>
  <div
    v-show="allBackgroundImage.length"
    class="bottom-swiper"
  >
    <swiper
      ref="mySwiper"
      :options="currSwiperOption"
    >
      <swiper-slide
        v-for="(item,index) in allBackgroundImage"
        :key="index"
        :class="{'curr-click-swiper':index===currClickIndex}"
      >
        <div class="bg-wrapper">
          <img
            v-if="item"
            :src="item"
            alt="bg"
            class="bg-img"
          >
        </div>
      </swiper-slide>
    </swiper>

    <!-- 上一页按钮 -->
    <div
      class="swiper-button button-prev"
      @click="onSwiperButtonClick('prev')"
    >
      <mk-iconfont icon-class="left" />
    </div>
    <!-- 下一页按钮 -->
    <div
      class="swiper-button button-next"
      @click="onSwiperButtonClick('next')"
    >
      <mk-iconfont icon-class="right" />
    </div>
  </div>
</template>

<script>

import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'BottomSwiper',
  components: {
    swiper,
    swiperSlide
  },

  props: {
    materialData: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data () {
    return {
      swiperOption: {
        // 设置slider容器能够同时显示的slides数量(carousel模式)。
        // 可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。
        slidesPerView: 'auto',
        // 在carousel mode下定义slides的数量多少为一组。
        slidesPerGroup: 2,
        // 在slide之间设置距离（单位px）。
        spaceBetween: 10,
        // 当所有的内嵌图像（img标签）加载完成后Swiper会重新初始化
        updateOnImagesReady: true
      },

      currClickIndex: -1
    }
  },
  computed: {

    // 当前的swiper参数，
    currSwiperOption () {
      // vue实例变量
      const vm = this

      return {
        ...this.swiperOption,

        on: {
          imagesReady: function () {
          },

          click: function () {
            const { clickedIndex } = this
            this.slideTo(clickedIndex)
            vm.currClickIndex = clickedIndex
            vm.$emit('on-click', clickedIndex)
          }
        }
      }
    },

    swiper () {
      return this.$refs.mySwiper.swiper
    },

    // 获取所有页面里面的背景组件的背景图oss地址
    allBackgroundImage () {
      const allBackgroundImage = []
      this.materialData.pages.map(pageItem => {
        pageItem.components.map(cItem => {
          // 背景的组件
          if (cItem.name === 'MkBackgroundDefault') {
            if (cItem.props.background.match('oss-cn-hangzhou')) {
              // 背景组件-里面的背景图
              allBackgroundImage.push(cItem.props.background + '?x-oss-process=image/auto-orient,0/format,jpg/quality,Q_80/resize,w_400')
            } else {
              allBackgroundImage.push('')
            }
          }
        })
      })

      return allBackgroundImage
    }
  },
  mounted () {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
  },
  created () {},
  methods: {
    // 左右按钮点击事件
    onSwiperButtonClick (type) {
      if (type === 'next') {
        this.swiper.slideNext()
      } else if (type === 'prev') {
        this.swiper.slidePrev()
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.bottom-swiper {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 112px;
  padding: 6px 40px;
  color: #fff;
  box-sizing: border-box;
  background-color: rgba(0, 0, 0, 0.5);

  .swiper-container {
    .swiper-slide {
      width: 100px;
    }

    .curr-click-swiper {
      .bg-wrapper {
        border-color: #009cff;
      }
    }

    .bg-wrapper {
      position: relative;
      width: 100px;
      height: 100px;
      box-sizing: border-box;
      border: 3px solid transparent;
      background-color: #fff;

      @extend .cursor;

      .bg-img {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  .swiper-button {
    position: absolute;
    top: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 65px;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.5);

    .iconfont {
      color: #fff;
      font-weight: 500;
    }

    @extend .cursor;
  }

  .button-prev {
    left: 6px;
  }

  .button-next {
    right: 6px;
  }
}
</style>
